(ns livefeed.footer.message-input
  (:require [reagent.core :as reagent :refer [atom with-let]]
            [reagent.dom :as rdom]
            [clojure.string :as str]
            [livefeed.i18n :refer [translate]]
            [livefeed.tunnus :as tunnus]
            [livefeed.icons :as icons]
            [livefeed.message-status :as status]
            [livefeed.properties :refer [get-property]]
            [livefeed.state :as state]
            [livefeed.websocket :as websocket]))

(def max-message-length 400)
(def min-rows 1)
(def max-rows 3)
(def line-height 18)
(def padding 22)
(def min-height (+ line-height padding))

(defn input-box [value placeholder on-change on-key-press disabled? input-ref]
  (reagent/create-class
   {:component-did-update (fn [this]
                            (let [elem (rdom/dom-node this)]
                              (set! (.-rows elem) min-rows)
                              (let [extra-rows (/ (- (.-scrollHeight elem) min-height)
                                                  line-height)]
                                (set! (.-rows elem) (min (+ min-rows extra-rows)
                                                         max-rows)))))
    :reagent-render       (fn [value placeholder on-change on-key-press disabled? input-ref]
                            [:textarea.yle-livefeed__input__textarea
                             {:placeholder  placeholder
                              :rows         1
                              :value        value
                              :on-focus     (fn [e]
                                              (if (-> @state/tunnus-user :nick nil?)
                                                (do
                                                  (-> e .-target .blur)
                                                  (tunnus/require-nick!))
                                                (reset! state/input-focused? true)))
                              :on-blur      #(reset! state/input-focused? false)
                              :on-change    on-change
                              :on-key-press on-key-press
                              :disabled     disabled?
                              :max-length   max-message-length
                              :ref          input-ref}])}))

(defn component [placeholder input-ref value]
  (with-let [value-saver (fn []
                           (let [message @value]
                             (when-not (str/blank? message)
                               (let [success? (websocket/send-message message)]
                                 (when-let [on-message-sent (get-property :on-message-sent)]
                                   (on-message-sent success?))
                                 (if success?
                                   (do
                                     (reset! state/input-focused? false)
                                     (reset! value ""))
                                   (status/send-failed))))))
             on-change (fn [e]
                         (if (and @state/logged-in (-> @state/tunnus-user :nick nil?))
                           (tunnus/require-nick!)
                           (reset! value (-> e .-target .-value))))
             on-key-press (fn [e]
                            (when (= "Enter" (.-key e))
                              (.preventDefault e)
                              (value-saver)))
             on-click (get-property :on-textfield-click)]
    (let [show-send-button? (or (empty? @state/feed-reactions)
                                @state/input-focused?
                                (not (str/blank? @value)))]
      [:<>
       [:div.yle-livefeed__input__textarea__container
        {:class (when show-send-button? :yle-livefeed__input__textarea__container--full-width)}
        (when on-click
          [:div.yle-livefeed__input__textarea__cover {:on-click on-click}])
        (if on-click
          [input-box @value placeholder nil nil true input-ref]
          [input-box @value placeholder on-change on-key-press false input-ref])
        [:div.yle-livefeed__input__textarea__length
         (str (count @value) "/" max-message-length)]]
       (when show-send-button?
         [:button.yle-livefeed__input__send-button
          {:on-click value-saver}
          icons/send])])))
